import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components';
import { Box } from '../Box/Box';
import { Card } from '../Card/Card';
import { Flex } from '../Flex/Flex';
import { applyVariations, colorSchemeCustomForeground } from '../utils/utils';
export const HugCard = /*#__PURE__*/styled(Card).withConfig({
  displayName: "Hugstyled__HugCard",
  componentId: "sc-104xekr-0"
})(["overflow:hidden;", " ", ""], applyVariations('Hug'), ({
  colorScheme,
  theme
}) => {
  const computedColorScheme = themeGet(`colorSchemes.${colorScheme}`)({
    theme
  });
  return colorScheme ? `
        border-color: ${computedColorScheme.foreground !== theme.colors.white ? computedColorScheme.foreground : computedColorScheme.background};
      ` : '';
});
export const BorderConcealer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Hugstyled__BorderConcealer",
  componentId: "sc-104xekr-1"
})(["& > *{border:0 !important;}"]);
export const Header = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "Hugstyled__Header",
  componentId: "sc-104xekr-2"
})(["", ""], colorSchemeCustomForeground);